function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.55 1.943a4.606 4.606 0 100 9.212 4.606 4.606 0 000-9.212zM1 6.549a5.55 5.55 0 119.792 3.577l4.07 4.07a.472.472 0 01-.667.666l-4.07-4.07A5.55 5.55 0 011 6.55zm5.55-2.647c.26 0 .47.21.47.471v1.705h1.705a.472.472 0 010 .943H7.021v1.704a.472.472 0 01-.943 0V7.021H4.373a.472.472 0 110-.943h1.705V4.373c0-.26.21-.471.471-.471z",
  fill: "#2D2D2D"
});
function SvgAcercar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Acercar.svg";
export { SvgAcercar as ReactComponent };